import { render } from "./FullLogo.vue?vue&type=template&id=4893b76b&scoped=true"
import script from "./FullLogo.vue?vue&type=script&lang=js"
export * from "./FullLogo.vue?vue&type=script&lang=js"

import "./FullLogo.vue?vue&type=style&index=0&id=4893b76b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4893b76b"]])

export default __exports__